

























































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import FactoryResponse from '@/factories/FactoryResponse'
import CadastroInterceptor from '@finx/web-repository/src/apis/Cadastro/CadastroInterceptor'
import BackofficeCadastroMedicoConviteForm from '@/components/Backoffice/sessao/cadastro-medico/BackofficeCadastroMedicoConviteForm.vue'
import BackofficeCadastroMedicoConviteTable from '@/components/Backoffice/sessao/cadastro-medico/BackofficeCadastroMedicoConviteTable.vue'
import BackofficeMedicosCadastradosTable from '@/components/Backoffice/sessao/cadastro-medico/BackofficeMedicosCadastradosTable.vue'
import BackofficeMedicosCadastradosForm from '@/components/Backoffice/sessao/cadastro-medico/BackofficeMedicosCadastradosForm.vue'
import BackofficeCadastroMedicoMedicosEAssistentesTable from '@/components/Backoffice/sessao/cadastro-medico/BackofficeCadastroMedicoMedicosEAssistentesTable.vue'
import ModalBackofficeCadastroMedicoAssociarCadastro from '@/components/Backoffice/sessao/cadastro-medico/ModalBackofficeCadastroMedicoAssociarCadastro.vue'

/** EventBus */
import EventBus from '@/plugins/EventBus'

const factory = new FactoryResponse()
const api = new CadastroInterceptor()

@Component({
  components: {
    BackofficeCadastroMedicoConviteForm,
    BackofficeCadastroMedicoConviteTable,
    BackofficeMedicosCadastradosForm,
    BackofficeMedicosCadastradosTable,
    BackofficeCadastroMedicoMedicosEAssistentesTable,
    ModalBackofficeCadastroMedicoAssociarCadastro,
  },
})
export default class ViewBackofficeCadastroMedico extends Vue {
  $refs!: {
    cadastroMedicoConviteForm: any,
    cadastroMedicoConviteTable: any,
    cadastroMedicoMedicosCadastradosForm: any,
    cadastroMedicoMedicosCadastradosTable: any,
    cadastroMedicoMedicosEAssistentesTable: any,
  }

  get paginationMedicosCadastrados() {
    return this.getBackofficeCadastroMedicoStore.paginationMedicosCadastrados
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.getBackofficeCadastroMedicoStore.getHospitalCurrentUser()
    await this.getBackofficeCadastroMedicoStore.getConvites()
    await this.getCbosAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async getCbosAll() {
    const request = await api.getAllowAnonymous('cbos')
    this.getBackofficeCadastroMedicoStore.setCbos(request.data)
    return factory.build(request)
  }

  tb: string = 'tab-1'
  get tabs() { return this.tb }
  set tabs(value: string) { this.tb = value }

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  async tabChange(e: string) {
    let tab = ''
    switch (e) {
      case 'tab-1':
        tab = 'convites'
        break
      case 'tab-2':
        tab = 'medicosCadastrados'
        break
      case 'tab-3':
        tab = 'medicosEAssistentes'
        break
      default:
        tab = 'convites'
    }

    this.$nextTick(async () => {
      if (tab === 'convites') {
        await this.getBackofficeCadastroMedicoStore.getConvites()
        this.$refs.cadastroMedicoConviteForm.$refs.formConvite.reset()
      }

      if (tab === 'medicosCadastrados') {
        await this.getBackofficeCadastroMedicoStore.getAllCadastrosMedicosByUsuarioHospital(this.paginationMedicosCadastrados)
        this.$refs.cadastroMedicoMedicosCadastradosForm.resetFormCadastro()
      }

      if (tab === 'medicosEAssistentes') {
        await this.getBackofficeCadastroMedicoStore.loadMedicoAssistentesAll()
      }
    })
  }

  reset() {
    this.getBackofficeCadastroMedicoStore.setDisableOnResend(false)
  }

  beforeDestroy() {
    this.reset()
    this.$refs.cadastroMedicoConviteForm.$refs.formConvite.reset()
    this.$refs.cadastroMedicoMedicosCadastradosForm.resetFormCadastro()
    this.getBackofficeCadastroMedicoStore.clearConvite()
    this.getBackofficeCadastroMedicoStore.clearConvites()
    this.getBackofficeCadastroMedicoStore.clearConviteSearch()
    this.getBackofficeCadastroMedicoStore.clearMedicoSearch()

    this.getBackofficeCadastroMedicoStore.clearMedicos()
    this.getBackofficeCadastroMedicoStore.clearMedicosSearch()
    this.getBackofficeCadastroMedicoStore.clearMedicoCadastrado()

    this.getBackofficeCadastroMedicoStore.setMedicoReadonly(false)
    this.getBackofficeCadastroMedicoStore.setPodeSerAlterado(false)

    this.getBackofficeCadastroMedicoStore.clearMedicoASerAssociado()

    this.tabs = 'tab-1'
  }

  windowSize: number = 0
  onResize() { this.windowSize = window.innerWidth }

  get breakpoint() { return this.windowSize >= 768 }

  async mounted() {
    this.getBackofficeCadastroMedicoStore.setMedicoReadonly(false)
    this.onResize()
    await this.init()
  }
}
